module.exports = __webpack_public_path__ + "static/media/ext08.adf42de5.jpg";